// extracted by mini-css-extract-plugin
export default {"wrap":"skin1-module_wrap_hhGPG","playItem":"skin1-module_playItem_9o0Zy"};